export default __webpack_public_path__ + "a4143c2b5d8c8a19931389fa03a0469a3b1591c4ea67bf39c82c001e0494a597.svg";